import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { AgGrid } from '../AgGrid';
import { getOrdersColumnDefinitions } from '../../helpers/columnDefinitions';
import { orderLineStatusLookupCodes } from '../../enums';

const styles = theme => ({});

// Read-only clone of OrdersGrid for the QA role: search/filter only, no row-click
// navigation, no editing, and no bulk actions.
export const QaAllOrdersGrid = withStyles(styles)(props => {
  const { classes } = props;

  const columnDefinitions = getOrdersColumnDefinitions('admin', 'admin', false).filter(
    colDef => colDef.headerName !== 'PDF',
  );
  const defaultStatusCodeValues = Object.keys(orderLineStatusLookupCodes).filter(
    code => code !== 'CL-DELIVERED' && code !== 'PO-ASSIGNED' && code !== 'IQ-PENDING',
  );

  return (
    <div className={classnames('flex-1', 'card', 'border-left-green')} style={{ flex: 1, alignSelf: 'stretch' }}>
      <AgGrid
        gridData={[]}
        columnDefs={columnDefinitions}
        redirectOnClick={false}
        editOnClick={false}
        allowServerExport={false}
        datasourceUrl={'/orders'}
        useDatasource={true}
        gridName={'MAIN_GRID'}
        defaultFilters={[
          {
            name: 'orderLineStatusLookupCode',
            model: {
              filterType: 'set',
              values: defaultStatusCodeValues,
            },
          },
        ]}
        className={'ag-theme-material'}
      />
    </div>
  );
});

QaAllOrdersGrid.propTypes = {};

QaAllOrdersGrid.defaultProps = {};
